import React from 'react'
import PropTypes from 'prop-types'
import { Copy, Icon, Flex } from '@elparking/components'
import { IconContainer } from 'rental-car-contract/js/ui/IconContainer'
const SuccessMessage = ({ icon, message }) => <Flex background='success_light' alignItems='center' padding='0.5em' margin='0.5em 0em' width='100%'>
    {icon && <IconContainer backgroundColor='success_support'>
        <Icon type={icon} size='small' fontColor='success_dark' />
    </IconContainer>}
    <Copy as='span' fontSize='xSmall' fontWeight='book' padding='0 0 0 1em'>
        {message}
    </Copy>
</Flex>

SuccessMessage.propTypes = {
    icon: PropTypes.string,
    message: PropTypes.object,
}

SuccessMessage.defaultProps = {
    icon: 'ok',
}

export default SuccessMessage
